import MapView from './MapView';
import Login from './Login';
import { useState, useEffect } from 'react';
import axios from 'axios';

function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('token'));
  const [sessionMsg, setSessionMsg] = useState('');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('first_name');
    setLoggedIn(false);
  };

  useEffect(() => {
    const handler = () => {
      handleLogout();
      setSessionMsg('Your session was ended because the server went offline due to inactivity. Sign in to reconnect.');
    };
    window.addEventListener('ec2-unavailable', handler);
    return () => window.removeEventListener('ec2-unavailable', handler);
  }, []);

  return (
    <div className="App">
      {loggedIn
        ? <MapView onLogout={handleLogout} />
        : <Login onLogin={() => { setSessionMsg(''); setLoggedIn(true); }} sessionMsg={sessionMsg} />
      }
    </div>
  );
}

// Auto sign-out when EC2 is unreachable (502/503/504 or no response)
axios.interceptors.response.use(
  r => r,
  err => {
    const status = err.response?.status;
    const isDown = !err.response || status === 502 || status === 503 || status === 504;
    if (isDown && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('first_name');
      window.dispatchEvent(new Event('ec2-unavailable'));
    }
    return Promise.reject(err);
  }
);

export default App;
